module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "fluid dark-top danger",
    attrs: {
      "dialog": "modal-lg"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('view-header', {
    attrs: {
      "title": "Cancel reservation",
      "icon": "alert"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "p-4 col-5 sidebar"
  }, [_c('h5', {
    staticClass: "bold mb-3"
  }, [_vm._v("Payment history")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Paid with")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v("Amount")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.payments), function(payment) {
    return _c('tr', {
      staticClass: "bg-lighter"
    }, [_c('td', [_vm._v("\n                            " + _vm._s(_vm._f("moment")(payment.date, 'YYYY-MM-DD')) + "\n                            "), _c('div', {
      staticClass: "dark fs-smaller"
    }, [_vm._v(_vm._s(_vm._f("moment")(payment.date, 'HH:mm')))])]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(payment.type) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v("\n                            " + _vm._s(payment.value) + _vm._s(payment.currency) + "\n                        ")])])
  }), 0), _vm._v(" "), _c('tfoot', [_c('tr', [_c('td', {
    staticClass: "fs-normal bold bg-lighter text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("\n                            Total paid: " + _vm._s(_vm.total.toFixed(2)) + "€\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-7 p-4 main"
  }, [_c('h5', {
    staticClass: "bold mb-2"
  }, [_vm._v("Select payment details")]), _vm._v(" "), _c('div', {
    staticClass: "fs-small"
  }, [_vm._v("\n                By cancelling this reservation you are creating a credit note. This can not be undone.\n            ")]), _vm._v(" "), _c('cancellation-methods', {
    on: {
      "validateRefunds": _vm.validateRefunds,
      "updateRefunds": _vm.updateRefunds
    }
  }), _vm._v(" "), _c('label', [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.billing.description),
      expression: "reservation.billing.description"
    }],
    staticClass: "full",
    attrs: {
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.reservation.billing.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation.billing, "description", $event.target.value)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn tertiary wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn blue wider",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reschedule
    }
  }, [_vm._v("No, reschedule")]), _vm._v(" "), _c('button', {
    staticClass: "btn action wider",
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.erase
    }
  }, [_vm._v("Yes, I'm sure")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1dbfc2a6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationCancel.vue
// module id = 1568
// module chunks = 0